import axios from "../utils/axios";

// 🏢 Get shipment
export const getActiveShipment = async () => {
  const response = await axios.get("/api/ExpeditionSetting/GetAllActive");
  //console.log(response);
  return response.data;
};

// 🏢 Get shipment detail
export const getActiveShipmentDetail = async (expeditionId) => {
  const response = await axios.get("/api/ExpeditionSetting/GetDetail", {
    params: { expeditionSettingId: expeditionId },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get single address
export const getSingleShipment = async (expeditionId) => {
  const response = await axios.get("/api/ExpeditionSetting/GetSingleItem", {
    params: { Id: expeditionId },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get invoice tracking
export const getInvoiceTracking = async (code) => {
  const response = await axios.get("/api/ExpeditionSetting/GetInvoiceTracking", {
    params: { code },
  });
  //console.log(response);
  return response.data;
};

export const setPrimaryAddress = async (addressId) => {
  const response = await axios.post("/api/Address/SetPrimaryAddress", null, {
    params: { addressId },
  });
  //console.log(response);
  return response.data;
};
